const ru = {
  nav: {
    home: "Главная",
    register: "Регистрация",
    login: "Войти",
    support: "Поддержка",
    pricing: "Тарифы",
  },
  home: {
    hero_badge: "Премиум Email Платформа Азербайджана",
    hero_title_1: "Выведите",
    hero_title_2: "Email на",
    hero_title_3: "Новый Уровень",
    hero_subtitle: "Современный дизайн, мощная безопасность, поддержка трёх языков. Полностью измените опыт работы с email с emailaze.",
    hero_cta: "Начать Бесплатно",
    hero_login: "Войти",
    trust1: "Шифрование AES-256",
    trust2: "99.9% Доступность",
    trust3: "Соответствие GDPR",
    logos_label: "Доверяют Компании",
    features_badge: "Почему emailaze?",
    features_title: "Всё Продумано",
    features_subtitle: "Каждая функция, которая вам нужна, без лишнего.",
    feature1_title: "Полная Безопасность",
    feature1_desc: "Сквозное шифрование AES-256. Все ваши данные полностью защищены, без доступа третьих лиц.",
    feature2_title: "Молниеносная Скорость",
    feature2_desc: "Сверхнизкая задержка благодаря локальным серверам в Баку. Ваши письма доставляются мгновенно.",
    feature3_title: "Поддержка 3 Языков",
    feature3_desc: "Полная поддержка азербайджанского, английского и русского языков.",
    feature4_title: "Умная Фильтрация",
    feature4_desc: "Фильтр спама на основе AI. Точность обнаружения 99.8%, важные письма всегда приходят.",
    how_badge: "Как Это Работает",
    how_title: "Начните за 3 Шага",
    how_subtitle: "Откройте почтовый аккаунт всего за 5 минут.",
    step1_num: "01",
    step1_title: "Зарегистрируйтесь",
    step1_desc: "Регистрация за 60 секунд с именем, email и паролем. Кредитная карта не требуется.",
    step2_num: "02",
    step2_title: "Настройте Аккаунт",
    step2_desc: "Привяжите email к домену @emailaze.com или добавьте свой домен.",
    step3_num: "03",
    step3_title: "Начните Пользоваться",
    step3_desc: "Используйте из браузера, мобильного приложения или любого устройства через IMAP/SMTP.",
    stats_badge: "emailaze в цифрах",
    stats_title: "Доверие Тысяч Пользователей",
    stats_desc: "Присоединяйтесь к самой быстрорастущей email платформе Азербайджана.",
    stat1_num: "50,000+",
    stat1_label: "Активных Пользователей",
    stat2_num: "99.9%",
    stat2_label: "Доступность Серверов",
    stat3_num: "24/7",
    stat3_label: "Техническая Поддержка",
    stat4_num: "< 50мс",
    stat4_label: "Средняя Задержка",
    reviews_badge: "Отзывы Пользователей",
    reviews_title: "Они Уже Выбрали",
    cta_title: "Улучшите Email Сегодня",
    cta_subtitle: "Начните с бесплатного плана. Кредитная карта не нужна.",
    cta_btn: "Начать Сейчас — Бесплатно",
  },
  login: {
    title: "Добро Пожаловать",
    subtitle: "Войдите в аккаунт emailaze",
    email: "Email адрес",
    email_placeholder: "имя@emailaze.com",
    password: "Пароль",
    password_placeholder: "Введите пароль",
    remember: "Запомнить меня",
    forgot: "Забыли пароль?",
    btn: "Войти",
    or: "или",
    no_account: "Нет аккаунта?",
    register_link: "Зарегистрироваться",
    secure: "Защищённое SSL соединение",
  },
  register: {
    title: "Создать Аккаунт",
    subtitle: "Выведите email на новый уровень с emailaze",
    firstname: "Имя",
    lastname: "Фамилия",
    email: "Email адрес",
    email_placeholder: "имя.фамилия@emailaze.com",
    phone: "Номер телефона",
    phone_placeholder: "+994 50 000 00 00",
    password: "Пароль",
    password_placeholder: "Минимум 8 символов",
    confirm_password: "Подтверждение пароля",
    confirm_password_placeholder: "Введите пароль повторно",
    terms: "Принимаю условия использования и политику конфиденциальности",
    terms_link: "Условия",
    btn: "Создать Аккаунт",
    already: "Уже есть аккаунт?",
    login_link: "Войти",
    feature1: "Бесплатный план — кредитная карта не нужна",
    feature2: "Полная защита шифрованием AES-256",
    feature3: "Поддержка языков AZ, EN, RU",
    feature4: "Доступ с любого устройства",
    error_password: "Пароли не совпадают",
    error_terms: "Необходимо принять условия",
    success: "Аккаунт создан!",
    success_msg: "Ссылка подтверждения отправлена на ваш email.",
  },
  pricing: {
    hero_tag: "Прозрачные Цены",
    hero_title: "Выберите Подходящий План",
    hero_subtitle: "Все планы включают шифрование AES-256, поддержку 24/7 и доступность 99.9%.",
    monthly: "Ежемесячно",
    annual: "Ежегодно",
    annual_badge: "скидка 20%",
    popular: "Самый Популярный",
    plan1_name: "Бесплатно",
    plan1_desc: "Идеально для начала",
    plan1_price_monthly: "₼0",
    plan1_price_annual: "₼0",
    plan2_name: "Pro",
    plan2_desc: "Для частных лиц и небольших команд",
    plan2_price_monthly: "₼15",
    plan2_price_annual: "₼12",
    plan3_name: "Бизнес",
    plan3_desc: "Для больших команд и корпораций",
    plan3_price_monthly: "₼49",
    plan3_price_annual: "₼39",
    per_month: "/мес",
    get_started: "Начать",
    contact_sales: "Связаться с продажами",
    feature_table_title: "Сравнение Планов",
    feature_table_subtitle: "Сравните функции всех планов",
    cta_title: "Ещё Не Решили?",
    cta_subtitle: "Наша команда поможет выбрать подходящий план.",
    cta_btn: "Поговорить с Экспертом",
  },
  support: {
    hero_title: "Как Мы Можем Помочь?",
    hero_placeholder: "Введите ваш вопрос...",
    channel1_title: "Телефонная Поддержка",
    channel1_num: "+994 12 000 00 00",
    channel1_hours: "Будни 09:00 - 18:00",
    channel2_title: "Email Поддержка",
    channel2_addr: "support@emailaze.com",
    channel2_time: "Ответ в течение 24 часов",
    channel3_title: "Онлайн Чат",
    channel3_btn: "Начать",
    channel3_status: "Сейчас активен",
    faq_title: "Часто Задаваемые Вопросы",
    faq_subtitle: "Ответы на самые популярные вопросы",
    form_title: "Напишите Нам",
    form_name: "Имя Фамилия",
    form_email: "Email",
    form_subject: "Тема",
    form_message: "Ваше сообщение",
    form_btn: "Отправить",
    form_success: "Сообщение отправлено! Скоро ответим.",
  },
  footer: {
    desc: "emailaze.com — Современная, быстрая и безопасная платформа email-хостинга для граждан Азербайджана.",
    product: "ПРОДУКТ",
    pricing_link: "Тарифы",
    features: "Функции",
    security: "Безопасность",
    company: "КОМПАНИЯ",
    about: "О нас",
    blog: "Блог",
    careers: "Карьера",
    help: "ПОДДЕРЖКА",
    support_link: "Центр поддержки",
    contact: "Контакты",
    docs: "Документация",
    legal: "ПРАВОВАЯ",
    terms: "Условия использования",
    privacy: "Политика конфиденциальности",
    gdpr: "GDPR",
    copyright: "© 2026 emailaze. Все права защищены.",
  },
};

export default ru;
